import { render, staticRenderFns } from "./TheQrCodeLayout.vue?vue&type=template&id=16f4f6ed&scoped=true&"
import script from "./TheQrCodeLayout.vue?vue&type=script&lang=js&"
export * from "./TheQrCodeLayout.vue?vue&type=script&lang=js&"
import style0 from "./TheQrCodeLayout.vue?vue&type=style&index=0&id=16f4f6ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f4f6ed",
  null
  
)

export default component.exports